angular.module('rms.common', ['sodCommon', 'ngRoute', 'ui.tinymce']);


